export const JIRA_LOGIN_PERMISSION_VIOLATION = 'permission-violation';
export const ARJ_LICENSE_VIOLATION = 'license-violation';
export const ARJ_PLAN_NOT_FOUND = 'plan-not-found';
export const ARJ_SCENARIO_NOT_FOUND = 'scenario-not-found';
export const ARJ_REPORT_NOT_FOUND = 'report-not-found';
export const ARJ_NO_PLAN_PERMISSION = 'no-plan-permission';
export const GENERIC = 'GENERIC' as const;

export const PLAN = 'PLAN' as const;
export const SCENARIO = 'SCENARIO' as const;

export type Entity = typeof PLAN | typeof SCENARIO;

export const PACKAGE_NAME = 'jiraSpaAppsAdvancedRoadmaps' as const;
export const TEAM_NAME = 'advanced-roadmaps' as const;
